export enum DiscountRateType {
    TRIPLE_NET = "TRIPLE_NET",
    GROSS = "GROSS"
}

export type DiscountRate = {
    selectedDiscountRate: DiscountRateType;
}